const SHARED_FEATURES = [
  '+79.000 kanalen, +249.000 films en series',
  'Amazon Prime, Videoland, Viaplay, NPO Start Plus, Discovery+, HBO Max, Netflix, Apple+, Disney+...',
  'Bekijk TVDiamonda live via DAZN Nederland',
  'DAZN F1 en Viaplay voor Formule 1',
  'Onbeperkte keuze uit films en series',
  'Kwaliteit SD / HD / FULL HD / 4K / 8K',
  'Snel dankzij stabiele servers',
  'Compatibel met alle apparaten',
  'Regelmatig bijgewerkt',
  '15 dagen geld-terug-garantie',
];

export const STANDARD_PLANS = [
  {
    id: 'basic',
    title: 'BASIS PAKKET',
    originalPrice: '59,00 €',
    price: '49,00 €',
    period: '15 MAANDEN',
    badge: null,
    screens: 1,
    isPopular: false,
    link: 'https://laligaiptv.com/order.php?id=29',
    features: ['Eredivisie, UCL & F1 Seizoen 2026/27 — Alle wedstrijden in HD/4K zonder onderbrekingen', ...SHARED_FEATURES],
    showAdultContent: false,
  },
  {
    id: 'premium',
    title: 'PREMIUM PAKKET',
    originalPrice: '79,00 €',
    price: '59,00 €',
    period: '18 MAANDEN',
    badge: 'MEEST POPULAIR',
    screens: 1,
    isPopular: true,
    link: 'https://laligaiptv.com/order.php?id=39',
    features: ['Eredivisie, UCL & F1 Seizoen 2026/27 — Alle wedstrijden in HD/4K zonder onderbrekingen', 'Kanalen + Films voor Volwassenen (met wachtwoord) 🔞', ...SHARED_FEATURES],
    showAdultContent: true,
  },
  {
    id: 'gold',
    title: 'GOUD PAKKET',
    originalPrice: '89,00 €',
    price: '69,00 €',
    period: '18 MAANDEN',
    badge: 'BESTE PRIJS',
    screens: 2,
    isPopular: false,
    link: 'https://laligaiptv.com/order.php?id=49',
    features: ['Eredivisie, UCL & F1 Seizoen 2026/27 — Alle wedstrijden in HD/4K zonder onderbrekingen', 'Kanalen + Films voor Volwassenen (met wachtwoord) 🔞', ...SHARED_FEATURES],
    showAdultContent: true,
  },
];

export const MULTI_SCREEN_PLANS = [
  {
    id: 'multi-2y',
    title: 'PLATINA PAKKET',
    originalPrice: '99,00 €',
    price: '79,00 €',
    period: '24 MAANDEN',
    badge: null,
    screens: 2,
    isPopular: false,
    link: 'https://laligaiptv.com/order.php?id=59',
    features: ['Eredivisie, UCL & F1 Seizoen 2026/27 — Alle wedstrijden in HD/4K zonder onderbrekingen', ...SHARED_FEATURES],
    showAdultContent: false,
  },
  {
    id: 'multi-3s',
    title: 'DIAMANT PAKKET',
    originalPrice: '129,00 €',
    price: '99,00 €',
    period: '18 MAANDEN',
    badge: 'MEEST POPULAIR',
    screens: 3,
    isPopular: true,
    link: 'https://laligaiptv.com/order.php?id=69',
    features: ['Eredivisie, UCL & F1 Seizoen 2026/27 — Alle wedstrijden in HD/4K zonder onderbrekingen', 'Kanalen + Films voor Volwassenen (met wachtwoord) 🔞', ...SHARED_FEATURES],
    showAdultContent: true,
  },
  {
    id: 'multi-4s',
    title: 'ELITE PAKKET',
    originalPrice: '189,00 €',
    price: '139,00 €',
    period: '18 MAANDEN',
    badge: 'BESTE WAARDE',
    screens: 4,
    isPopular: false,
    link: 'https://laligaiptv.com/order.php?id=89',
    features: ['Eredivisie, UCL & F1 Seizoen 2026/27 — Alle wedstrijden in HD/4K zonder onderbrekingen', 'Kanalen + Films voor Volwassenen (met wachtwoord) 🔞', ...SHARED_FEATURES],
    showAdultContent: true,
  },
];

export const LIFETIME_PLAN = {
  title: 'LEVENSLANG PAKKET',
  originalPrice: '279,00 €',
  price: '179,00 €',
  period: 'eenmalig',
  badge: 'BEPERKTE AANBIEDING',
  link: 'https://laligaiptv.com/order.php?id=119',
};
